import React from 'react';
import type { KpiFormProps } from '../types';
import { BoxedTileRow } from './boxed-tile-row';
import { COUNT_AVERAGE_DIGITS, figureTile } from './tile-figure';

export const TrioForm: React.FC<KpiFormProps> = ({ data, toDateOnly }) => {
    if (data.form !== 'trio') return null;

    const unit = { isCurrency: data.isCurrency, isPercent: data.isPercent };
    const toDateTile = figureTile(data.toDate, unit);

    if (toDateOnly) {
        return <BoxedTileRow highlightIndex={0} tiles={[toDateTile]} />;
    }

    return (
        <BoxedTileRow
            highlightIndex={0}
            tiles={[
                { title: 'Total to date', ...toDateTile },
                {
                    title: 'Weekly avg.',
                    ...figureTile(data.weekly, unit, COUNT_AVERAGE_DIGITS),
                },
                {
                    title: 'Daily avg.',
                    ...figureTile(data.daily, unit, COUNT_AVERAGE_DIGITS),
                },
            ]}
        />
    );
};
